import React from 'react';
import { useStore } from 'storesProvider/storeContext';

const useIsAuthorization = () => {
  const { userStore } = useStore();
  return userStore.user;
};

export default useIsAuthorization;
